import {Component,Input,Output,EventEmitter} from '@angular/core';
import {MatDrawer} from '@angular/material/sidenav';
import {AppService} from '../../app.service';

@Component({
	selector:'beatfulness-drawer',
	templateUrl:'./drawer.component.html',
	styleUrls:['./drawer.component.scss']
})
export class DrawerComponent{
	@Output() public drawerClosed:EventEmitter<any>=new EventEmitter<any>();
	@Input() drawerInput?:MatDrawer;
	appService:AppService;
	
	constructor(appService:AppService){
		this.appService=appService;
		this.drawerInput=undefined;
	}
	
	ngOnInit():void{
	}
	
	closeMenu():void{
		this.drawerClosed.emit();
	}
}
